import { render, staticRenderFns } from "./MinhasNotificacoesPage.vue?vue&type=template&id=57dc95ca"
import script from "./MinhasNotificacoesPage.vue?vue&type=script&lang=js"
export * from "./MinhasNotificacoesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports